import Marquee from "react-fast-marquee";

const words = ["RECOVERY", "LONGEVITY", "VITALITY", "COGNITION", "WEIGHT LOSS", "HEALING", "PERFORMANCE", "IMMUNITY"];

export default function MarqueeRibbon() {
  return (
    <div data-testid="marquee-ribbon" className="bg-[#EFECE5] py-6 overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {words.map((word, i) => (
          <span
            key={i}
            className="font-serif text-xl md:text-2xl font-light text-[#2A3324]/60 mx-12 md:mx-16 tracking-wider"
          >
            {word}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
